import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAl4r-ETxl2WjaGlsYvS6sN1esfwAQIuEs",
  authDomain: "farmacia-subito.firebaseapp.com",
  projectId: "farmacia-subito",
  storageBucket: "farmacia-subito.firebasestorage.app",
  messagingSenderId: "485075313623",
  appId: "1:485075313623:web:72401f0e04d8fcb80fa192"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// MANTIENE LOGIN DOPO CHIUSURA APP
setPersistence(auth, browserLocalPersistence);

// Messaging disabilitato per app mobile
export const messaging = null;

export const requestNotificationPermission = async () => {
  console.log('Notifiche non disponibili su mobile');
  return null;
};